import { eApplicationActions } from './eApplicationActions';
import { IOrderLinkRequest } from '../interfaces';

export interface IReplaceOrderLinkRequest {
  type: eApplicationActions.ReplaceOrderLinkRequest;
  payload: IOrderLinkRequest;
}

export const createReplaceOrderLinkRequestAction = (payload: IOrderLinkRequest): IReplaceOrderLinkRequest => ({
  type: eApplicationActions.ReplaceOrderLinkRequest,
  payload,
});
